module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Lady Bluebell and Her Magical Gardens")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch002#dedications",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedications")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch003#copyright-information",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch004#acknowledgement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#wookey-nook-the-garden-shed-and-friends",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wookey Nook the Garden Shed and Friends")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#the-garden-of-magic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Garden of Magic")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#the-rainbow-of-time",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rainbow of Time")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#lady-bluebells-magical-kitchen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lady Bluebell’s Magical Kitchen")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#you-can-make-your-own-fairy-cakes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Can Make Your Own Fairy Cakes")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#ingredients",
      "title": "Link target outside of Sample"
    }
  })]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#method",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#dame-ducks-birthday-party",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dame Duck’s Birthday Party")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-frog-and-dragonfly-pond",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Frog and Dragonfly Pond")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#the-wild-bird-garden",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wild Bird Garden")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#you-can-make-your-own-wild-bird-haven-and-your-own-wild-bird-food",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Can Make Your Own Wild Bird Haven and Your Own Wild Bird Food")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#an-ideal-place",
      "title": "Link target outside of Sample"
    }
  })]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#the-bird-fairies-secret",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#section",
      "title": "Link target outside of Sample"
    }
  })]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#recipe-a-mixture-of-as-many-as-possible-of-these-ingredients-is-ideal",
      "title": "Link target outside of Sample"
    }
  })]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#the-bird-fairies-method",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#the-garden-of-sunflowers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Garden of Sunflowers")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#section-1",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#recipe",
      "title": "Link target outside of Sample"
    }
  })]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#method-1",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#the-talking-tree-of-protection-and-calmbrae",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Talking Tree of Protection and Calmbrae")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#mrs-blacks-world-in-a-tree",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mrs Black’s World in a Tree")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#calmbrae-the-home-of-mrs-black",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Calmbrae: The Home of Mrs Black")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#think-kind-thoughts-and-nice-things-will-happen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Think Kind Thoughts and Nice Things Will Happen")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#learning-about-the-pixies-colours",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Learning About The Pixie’s Colours")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#primary-colours",
      "title": "Link target outside of Sample"
    }
  })]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#secondary-colours",
      "title": "Link target outside of Sample"
    }
  })]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#section-2",
      "title": "Link target outside of Sample"
    }
  })]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#tertiary-colours",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#the-garden-of-harmony",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Garden of Harmony")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#the-garden-of-roses",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Garden of Roses")])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#it-was-all-a-dream",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It Was All a Dream")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0